import { useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { useClaimDataEntriesQuery, useClaimQuery } from '../../../api/gql';
import { useSafeNavigation } from '../../../hooks/useSafeNavigation';
import { SetPaidModule } from '../../../modules/dialogs/set-paid';

export const ClaimSetPaidPage = () => {
  const { invoiceId } = useParams();
  const { safeNavigate } = useSafeNavigation();
  const queryClient = useQueryClient();

  if (!invoiceId) {
    throw new Error('Unexpected - route variable :invoiceId is missing.');
  }

  return (
    <SetPaidModule
      invoiceId={invoiceId}
      transNs={'page-claim-detail'}
      keyPrefix={'setPaidBox.dialog'}
      onSuccess={({ setDueAmount }) => {
        queryClient.setQueryData(useClaimQuery.getKey({ id: setDueAmount.id }), {
          invoice: { ...setDueAmount },
        });
        queryClient.invalidateQueries({
          queryKey: useClaimDataEntriesQuery.getKey({ id: invoiceId }),
        });
        safeNavigate(`/claim/${setDueAmount.id}`);
      }}
    />
  );
};
